"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GasCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GasCircleFilled = function GasCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 2A.75.75 0 0110 3.457V4.7c.168.056.319.123.465.202.49.261.873.645 1.134 1.134.262.489.401 1.029.401 2.036V9.93c0 1.007-.14 1.547-.4 2.036a2.724 2.724 0 01-1.1 1.115v.42a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-.42l-.085-.049A2.721 2.721 0 014.4 11.965c-.261-.489-.4-1.029-.4-2.035V8.071c0-1.007.14-1.547.4-2.036A2.726 2.726 0 015.536 4.9c.146-.079.298-.146.465-.202V3.457A.75.75 0 016.25 2h3.5zM8.368 6.516a2.12 2.12 0 00-.782 1.13 3.691 3.691 0 00-.086.845c-.34-.072-.417-.58-.417-.586a.084.084 0 00-.12-.063c-.017.008-.437.222-.461 1.073A1.502 1.502 0 008 10.5h.004A1.502 1.502 0 009.5 9c0-.042-.009-.158-.009-.158-.045-.597-.323-.97-.568-1.3-.227-.306-.423-.57-.423-.959a.083.083 0 00-.132-.067zM8.112 8.92c.036.121.105.22.172.315.097.137.196.279.214.52L8.5 9.8c0 .293-.224.532-.5.532s-.5-.239-.5-.532v-.033a.676.676 0 01.053-.264c.049.103.135.199.275.199a.083.083 0 00.084-.084c0-.118.002-.255.032-.379a.806.806 0 01.168-.319z",
    fill: "currentColor"
  }));
};

exports.GasCircleFilled = GasCircleFilled;
var _default = GasCircleFilled;
exports.default = _default;